<template>
  <div class="camera-container">
    <v-container>
      <div v-if="cameraDescriptions.length > 1">
        <v-select
          :items="cameraDescriptions"
          v-model="selectedCamera"
          :label="$t('roomControl.selectCamera')"
          @change="selectCamera"
          class="select-camera"
          item-text="title"
        ></v-select>
      </div>
      <div v-if="selectedCameraImage" class="image-container">
        <img :src="selectedCameraImage" class="center-image" />
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      selectedCamera: null,
      selectedCameraImage: "",
      refreshing: false,
      refreshInterval: null,
    };
  },
  computed: {
    ...mapState({
      items: ({ cameradialog }) => cameradialog.items,
    }),
    cameraDescriptions() {
      const locale = this.$config.language_key.toLowerCase();
      return this.items.map((item, index) => {
        let title = `${this.$t("app.roomCamera")} ${index + 1}`;
        if (item.i18n && item.i18n.length > 0) {
          const translation = item.i18n.find((el) => el.language === locale);
          if (translation) {
            title = translation.description;
          }
        }
        return { ...item, title };
      });
    },
  },

  methods: {
    ...mapActions("cameradialog", ["getRoomCamera"]),
    selectCamera() {
      if (this.selectedCamera && this.selectedCamera.image_base64) {
        this.selectedCameraImage = this.selectedCamera.image_base64;
        this.refreshImage();
      }
    },
    refreshImage() {
      if (!this.refreshing && this.selectedCamera) {
        this.refreshing = true;
        this.getRoomCamera()
          .then(() => {
            const updatedCamera = this.items.find(
              (item) => item.id === this.selectedCamera.id
            );
            if (updatedCamera && updatedCamera.image_base64) {
              this.selectedCameraImage = updatedCamera.image_base64;
            } else {
              this.selectedCameraImage = "";
            }
            this.refreshing = false;
          })
          .catch((error) => {
            console.error("Error refreshing image:", error);
            this.refreshing = false;
          });
      }
    },
  },
  created() {
    if (this.items.length > 0) {
      this.selectedCamera = this.cameraDescriptions[0];
      if (this.selectedCamera.image_base64) {
        this.selectedCameraImage = this.selectedCamera.image_base64;
      }
    }
    this.refreshImage();
    this.refreshInterval = setInterval(() => {
      this.refreshImage();
    });
  },
  destroyed() {
    clearInterval(this.refreshInterval);
  },
};
</script>

<style scoped>
.camera-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.image-container {
  text-align: center;
}

.center-image {
  max-width: 100%;
  height: auto;
  display: inline-block;
}
</style>
